import React, { useEffect } from 'react';
import PageProvider, { PAGES, usePage } from './Context/PageProvider';
import PrintersProvider from './Context/PrintersProvider';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import BongMaster from '~Scenes/Tables/Components/BongMaster';
import TableContextProvider from './Context/TableContext';
import StaffContextProvider from './Context/StaffProvider';
import DefaultLayout from './Components/Layout/DefaultLayout';
import ChequeContextProvider from './Context/ChequeContext';
import { useDeviceInfo, useLogger, useSelector, useWindowSize } from '~Hooks';
import { useHistory } from 'react-router';
import { handyBreakpoint } from '~Styles/breakpoints';

const HandyWrapper = () => {
  return (
    <PrintersProvider>
      <StaffContextProvider>
        <PageProvider>
          <TableContextProvider>
            <ChequeContextProvider>
              <Handy />
            </ChequeContextProvider>
          </TableContextProvider>
        </PageProvider>
      </StaffContextProvider>
    </PrintersProvider>
  );
};

const Handy = () => {
  const page = usePage();

  return (
    <DefaultLayout>
      <BongMaster />
      <SwitchTransition mode={'out-in'}>
        <CSSTransition key={page.current} timeout={200} classNames="slide">
          {PAGES[page.current].component}
        </CSSTransition>
      </SwitchTransition>
    </DefaultLayout>
  );
};

export default HandyWrapper;
